import {OrderPanel} from './OrderPanel';

export default OrderPanel;